import { DesignSystemPrimitive } from 'designSystem/types';
import { resolveTokenValue } from 'designSystem/tokens/resolver';
import * as S from './styles';

interface LayoutPrimitivePreviewProps {
	primitive: DesignSystemPrimitive;
}

export const LayoutPrimitivePreview = ({ primitive }: LayoutPrimitivePreviewProps) => {
	// Create inline styles from CSS properties, resolving token references
	const inlineStyles: React.CSSProperties = {};
	primitive.properties.forEach((prop) => {
		const cssProp = prop.name.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
		const resolvedValue = resolveTokenValue(prop.value);
		if (cssProp === 'display') {
			inlineStyles.display = resolvedValue as any;
		} else if (cssProp === 'flexDirection') {
			inlineStyles.flexDirection = resolvedValue as any;
		} else if (cssProp === 'gap') {
			inlineStyles.gap = resolvedValue;
		} else if (cssProp === 'gridTemplateColumns') {
			inlineStyles.gridTemplateColumns = resolvedValue;
		} else if (cssProp === 'padding') {
			inlineStyles.padding = resolvedValue;
		} else if (cssProp === 'margin') {
			inlineStyles.margin = resolvedValue;
		}
	});

	// Show a simple layout visualization
	return (
		<S.PrimitivePreview>
			<div
				style={{
					...inlineStyles,
					width: '100%',
					minHeight: '60px',
					backgroundColor: '#f5f5f5',
					border: '1px dashed #ddd',
					borderRadius: '4px',
					display: inlineStyles.display || 'flex',
				}}
			>
				{primitive.baseSelector.includes('grid') && (
					<>
						<div style={{ backgroundColor: '#ddd', borderRadius: '2px', minHeight: '20px' }} />
						<div style={{ backgroundColor: '#ddd', borderRadius: '2px', minHeight: '20px' }} />
					</>
				)}
				{primitive.baseSelector.includes('stack') && (
					<>
						<div
							style={{ backgroundColor: '#ddd', borderRadius: '2px', height: '12px', width: '80%' }}
						/>
						<div
							style={{ backgroundColor: '#ddd', borderRadius: '2px', height: '12px', width: '60%' }}
						/>
					</>
				)}
			</div>
		</S.PrimitivePreview>
	);
};
